import { FormStepperValidationEvent, FormStepperValidationEventClientServerEnum, OrganismFormStepperEvents } from 'wolf/components/organisms/o-form-stepper/o-form-stepper.events';
import ControllerBase from '../../../../global/js/ControllerBase';
import { MoleculeFormEvents, MoleculeFormEventTypes } from '../m-form/m-form.events';
import { FormstepWarrantyStep3Events } from './m-formstep-warranty-step-3.events';

interface ComponentRefs {
	primaryForm: 'primaryForm'
}
export default class ControllerFormstepWarrantyStep3 extends ControllerBase<ComponentRefs> {

	private static readonly componentRefs: ComponentRefs = {
		primaryForm: 'primaryForm',
	};

	/**
	 * The whole form is valid when:
	 * 1. All required fields are filled in
	 */
	private validationStates: Record<
		ComponentRefs['primaryForm'], boolean
	> = {
			primaryForm: false,
		};

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerFormstepWarrantyStep3.componentRefs));
		this.init();
	}

	private init(): void {
		this.domNodeListenerEvents();
	}

	/**
	 * @returns void
	 */
	private domNodeListenerEvents(): void {
		// listen for the o-form-stepper issuing external validation events
		// this will be when the user tries to advance to the next step
		window.addEventListener(FormstepWarrantyStep3Events.REQUEST_VALIDATION, (event: CustomEvent<FormStepperValidationEvent>) => {

			// validate the form and call success or error callback
			const formIsValid = this.validateFormRequiredFields();
			if (formIsValid) {
				if (event.detail.onValidationSuccess) event.detail.onValidationSuccess(FormStepperValidationEventClientServerEnum.Frontend);
			} else {
				if (event.detail.onValidationError) event.detail.onValidationError();
			}

		});

		// listen for the managed form submitting new validation events when the child form validation state changes
		this.$references.primaryForm.addEventListener(
			MoleculeFormEvents.VALIDATION_RAN,
			(e: CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>) => this.updateChildFormValidity(ControllerFormstepWarrantyStep3.componentRefs.primaryForm, e)
		);

	}

	/**
	 * Updates internal validation status of the form
	 * @param  {ComponentRefs['primaryForm']} form
	 * @param  {CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>} event
	 * @returns void
	 */
	private updateChildFormValidity(form: ComponentRefs['primaryForm'], event: CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>): void {
		this.validationStates[form] = event.detail;

		const formIsValid = this.validateFormRequiredFields();
		this.dispatchCustomEvent(OrganismFormStepperEvents.DISABLE_GO_TO_NEXT_STEP, !formIsValid, false, true)
	}

	/**
	 * Returns overall step validation
	 * @returns boolean
	 */
	private validateFormRequiredFields(): boolean {
		return this.validationStates.primaryForm;
	}
}
